import { TableMode } from '@/models/TableMode';
import { GameType } from '@/models/games/enums/GameType';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import {
    convertResultToRecord,
    parseDeckData,
} from '../../../utils/games/pokdeng';
import { PokerShow } from '../../games/PokerShow';
import { GameState } from '../../games/enums/GameState';
import { PokDengResult } from '../../games/pokdeng';
import { Poker } from '../../host/Poker';
import { CMDScInitPokdeng, ICommand } from '../live';
import { CMDLivePokdengData } from '../live/CMDLivePokdengData';
import { CMDPokdeng } from '../live/CMDPokdeng';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitPokDengHandler extends AbstractHandler {
    _command: CMDScInitPokdeng;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitPokdeng;
    }
    override convertResult(result: CMDLivePokdengData): PokDengResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseData.BaseResult),
            {
                fullDeck:
                    result.PokerData.length == 0 ||
                    result.PokerData.length == 12
                        ? parseDeckData(result.BaseData.JSON)
                        : undefined,
                PokerData: result.PokerData.map(
                    p =>
                        ({
                            SlotIndex: p.SlotIndex,
                            CardIndex: p.CardIndex - 1,
                        }) as Poker
                ),
            }
        ) as PokDengResult;
        return newResult;
    }
    convertPokerResult(result: CMDPokdeng): PokDengResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                fullDeck: parseDeckData(result.JSON),
            }
        ) as PokDengResult;
        return newResult;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        liveData.GameType = GameType.PokDeng;
        liveData.CurrentState = this._command.CurrentState;
        let results: Array<PokerShow>;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        if (this._command.CurrentState !== GameState.Idle) {
            const pokerDate = (liveData.CurrentResult as PokDengResult)
                .PokerData;
            if (pokerDate) {
                results = new Array<PokerShow>();
                for (let i = 0; i < pokerDate?.length; i++) {
                    results.push({
                        Slot: pokerDate[i].SlotIndex,
                        Card: pokerDate[i].CardIndex,
                    });
                }
            }
        }
        game.OldResult = this._command.OldResult.filter(o => {
            if (o.BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertPokerResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );
        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;

        const convertedRecord =
            liveData.CurrentState === GameState.Shuffle
                ? []
                : game.OldResult.map(r =>
                      convertResultToRecord(r as PokDengResult)
                  );

        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseData.BaseResult
                        .GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    gameType: GameType.PokDeng,
                    record: convertedRecord,
                })
            );
            if (results) {
                dispatch(
                    hostLiveSliceActions.updatePokerShow({
                        hostId: hostId,
                        results: results,
                    })
                );
            }
        });
    }
}
